import { render, staticRenderFns } from "./NavbarNotifications.vue?vue&type=template&id=57cbe0ea&scoped=true&"
import script from "./NavbarNotifications.vue?vue&type=script&lang=js&"
export * from "./NavbarNotifications.vue?vue&type=script&lang=js&"
import style0 from "./NavbarNotifications.vue?vue&type=style&index=0&id=57cbe0ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cbe0ea",
  null
  
)

export default component.exports